import React, { useContext, type FC } from 'react';

import { withCustomPaths } from '@lucid/utils';
import { useSmartlingStrings } from '@lucid/hooks';

import Box from '../box/box';
import Link from '../link/link';
import Text from '../text/text';
import LayoutContext from '../context/layout-context';

interface TemplateHubBreadcrumbData {
  name: string;
  href: string;
}

interface TemplateHubBreadcrumbsProps {
  parentCategory?: TemplateHubBreadcrumbData;
  category: string;
}

const TemplateHubBreadcrumbs: FC<TemplateHubBreadcrumbsProps> = ({ parentCategory, category }) => {
  const { shortCode, product } = useContext(LayoutContext);
  const withSmartling = useSmartlingStrings({
    keys: ['mktg_product_template_hub_page'],
    shortCode,
  });

  return (
    <Box
      as="nav"
      css={theme => ({
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        padding: `${theme.space.s64}px ${theme.space.s32}px`,
      })}
    >
      <ul
        css={theme => ({
          listStyle: 'none',
          display: 'inline-flex',
          flexWrap: 'wrap',
          marginLeft: 0,
          rowGap: theme.space.s8,
          '& > li:nth-of-type(n+2)': {
            marginLeft: theme.space.s8,
          },
          '& > li:not(:nth-last-of-type(1))::after': {
            content: '"/"',
            marginLeft: theme.space.s8,
          },
        })}
      >
        <li>
          <Link
            willPrependLangPrefix
            href={withCustomPaths(shortCode, product, 'product-template-hub')}
            variant="breadcrumbLink"
          >
            {withSmartling('mktg_product_template_hub_page')}
          </Link>
        </li>
        {parentCategory?.name && (
          <li>
            <Link href={parentCategory.href} variant="breadcrumbLink">
              {parentCategory.name}
            </Link>
          </li>
        )}
        <li>
          <Text css={theme => ({ fontWeight: theme.fontWeights.fw600, margin: 0 })}>{category}</Text>
        </li>
      </ul>
    </Box>
  );
};

export default TemplateHubBreadcrumbs;
